// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__+PytG","spin":"LoadingSpinner_spin__MtkTJ"};